import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Consegna',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Room service',
      [RoomServiceLocationType.TableService]: 'Servizio al tavolo',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Nome campanello (opzionale)',
    },
    company_name: {
      placeholder: 'Nome azienda (opzionale)',
    },
    customer_note: {
      placeholder: 'Istruzioni per la consegna (opzionale)',
    },
    order_instructions: {
      placeholder: "Inserisci istruzioni per l'ordine...",
    },
  },
};
